export default __webpack_public_path__ + "images/AJ.e8316b9.png";